import React from "react";
import PropTypes from "prop-types";
import "./Tag.css";

/**
 * Token-backed status tag used by the newer AMI screens.
 *
 * `solid` is for definitive states such as Final. `opacity` uses the light
 * state ramp behind darker text for lower-emphasis metadata such as demand.
 */
function Tag({ children, variant = "success", appearance = "solid", icon = null, className = "" }) {
  const classes = [
    "aie-tag",
    `aie-tag--${variant}`,
    `aie-tag--${appearance}`,
    className,
  ]
    .filter(Boolean)
    .join(" ");

  return (
    <span className={classes} title={typeof children === "string" ? children : undefined}>
      {icon ? <span className="aie-tag__icon">{icon}</span> : null}
      <span className="aie-tag__label">{children}</span>
    </span>
  );
}

Tag.propTypes = {
  children: PropTypes.node.isRequired,
  variant: PropTypes.oneOf(["success", "warning", "error", "info", "neutral"]),
  appearance: PropTypes.oneOf(["solid", "opacity"]),
  icon: PropTypes.node,
  className: PropTypes.string,
};

export default Tag;
